import React from 'react';

const fmt = (n) => (n ?? 0).toLocaleString();
const fmtDT = (s) => (s ? String(s).replace('T', ' ').slice(0, 16) : '—');
const fmtDur = (m) => (m == null ? '—' : `${Math.round(m)} min`);
const linkBtn = { background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: '#4338ca', fontWeight: 600, fontSize: 13, textAlign: 'left', textDecoration: 'underline', textUnderlineOffset: 2 };

export function EventTiles({ s, Tile }) {
  if (!s) return null;
  return (
    <div data-testid="feed-summary" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0,1fr))', gap: 12, marginBottom: 20 }}>
      <Tile k="attendances" label="Feed Rows (Attendances)" value={fmt(s.total_attendances)} sub={`${fmt(s.unique_attendees)} unique attendees`} />
      <Tile k="events" label="Events" value={fmt(s.total_events)} sub={`${fmt(s.total_sessions)} sessions`} />
      <Tile k="avg-duration" label="Avg Duration" value={`${fmt(s.avg_duration_minutes)} min`} sub="per attendance" />
      <Tile k="countries" label="Countries" value={fmt(s.total_countries)} sub="attendee countries" />
      <Tile k="top-event" label="Top Event" value={s.top_event?.name || '—'} sub={s.top_event ? `${fmt(s.top_event.attendances)} attendances` : null} />
    </div>
  );
}

export function EventTable({ rows, pii, onEvent }) {
  return (
    <div className="table-scroll">
      <table data-testid="feed-table">
        <thead>
          <tr>
            <th>Event</th><th>Session</th>{pii && <th>Attendee</th>}{pii && <th>Email</th>}<th>Company</th>
            <th>Country</th><th>Region</th><th>MS Course ID</th><th>Enrolled</th><th>Completed</th><th className="td-right">Duration</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={`${r.session_id}-${r.email}-${i}`} data-testid={`feed-row-${i}`}>
              <td style={{ fontSize: 13, maxWidth: 240 }}>
                {r.event_id ? (
                  <button style={linkBtn} onClick={() => onEvent({ id: r.event_id, title: r.event_title })} data-testid={`feed-event-link-${i}`} title={`${r.event_title || r.event_id} — view sessions and attendees`}>
                    {r.event_title || r.event_id}
                  </button>
                ) : (r.event_title || '—')}
              </td>
              <td style={{ fontSize: 12, maxWidth: 220 }}>{r.session_title || '—'}</td>
              {pii && <td style={{ fontSize: 13 }}>{r.learner_name || '—'}</td>}
              {pii && <td style={{ fontSize: 12, fontFamily: 'monospace', color: '#3182ce' }}>{r.email || '—'}</td>}
              <td style={{ fontSize: 12 }}>{r.company || '—'}</td>
              <td style={{ fontSize: 12 }}>{r.country || '—'}</td>
              <td style={{ fontSize: 12 }}>{r.region || '—'}</td>
              <td style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.ms_course_id || '—'}</td>
              <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{fmtDT(r.enrolled_at)}</td>
              <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{fmtDT(r.completed_at)}</td>
              <td className="td-right" style={{ fontWeight: 600 }}>{fmtDur(r.duration_minutes)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
